import { withTranslation } from 'react-i18next';
import Component from '../../components/Component';
import { isTrue } from '../../helpers/isTrue';
import TopAuthors from '../TopAuthors';
import TopCelebrities from '../TopCelebrities';

class DomainsWidgetContainer extends Component {
    constructor() {
        super();
        this.state = { emptyEntities: false };
        this.setIsEmptyEntities = this.setIsEmptyEntities.bind(this);
    }

    setIsEmptyEntities(value) {
        this.setState({ emptyEntities: value });
    }

    render() {
        const { t } = this.props;
        const isShowAuthors = !isTrue(this.props.report_permission_all_authors);
        return (
            <div className="discover-cards-ent-auth" style={{ height: '100%' }}>
                <div className={'py-2'}>
                    <TopCelebrities
                        setIsEmpty={this.setIsEmptyEntities}
                        emptyEntities={this.state.emptyEntities}
                        link={`/domains/${window.info.id}/entities/`}
                        header={t('discover.overview.top_entities.header')}
                        subheader={t('discover.overview.top_entities.subheader')}
                    />
                </div>
                <div className="py-2">
                    <TopAuthors
                        plan_type={this.props.plan_type}
                        header={t('discover.overview.top_authors.header')}
                        subheader={t('discover.overview.top_authors.subheader')}
                        link={`/domains/${window.info.id}/authors`}
                        isShowAuthors={isShowAuthors}
                    />
                </div>
            </div>
        );
    }
}

export default withTranslation()(DomainsWidgetContainer);
